module.exports = __webpack_public_path__ + "img/icon-arrow-2.6b2f17ca.svg";